import { createContext, useState, useEffect, useContext } from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import Loader from '../components/Loader';
import { LocalizationContext } from './index';
import { getEnvDomain } from '../utils/fetch';

export const UserContext = createContext();

export const UserProvider = (props) => {
    const [localization] = useContext(LocalizationContext);
    const [user, setUser] = useState(null);
    const [userLoading, setUserLoading] = useState(true);
    const [isStart, setIsStart] = useState(true);

    useEffect(() => {
        let extendSession = true;
        const extendSessionFun = async () => {
            if (extendSession && window.cet.accessmanagement && 'isLoggedInAsync' in window.cet.accessmanagement && (await window.cet.accessmanagement.isLoggedInAsync())) {
                extendSession = false;
                window.cet.accessmanagement.extendSessionAsync();
            }
        };
        const setExtendSession = () => {
            extendSession = true;
        };

        const onLogin = (ev) => {
            ev.preventDefault();
            var session = ev.detail.session;
            initUser(session);
        };
        const onLogout = (ev) => {
            ev.preventDefault();
            initUser();
        };
        const onSessionchange = (ev) => {
            ev.preventDefault();
            if (ev.detail.propertyNames.indexOf("schoolId") >= 0) {
                getUser(false);
            }
        };

        document.addEventListener("cet.accessmanagement.login", onLogin);
        document.addEventListener("cet.accessmanagement.logout", onLogout);
        document.addEventListener("cet.accessmanagement.sessionchange", onSessionchange);

        document.addEventListener("mousedown,touchstart,touchmove", setExtendSession);
        window.addEventListener('resize', setExtendSession);

        getUser(true);
        extendSessionFun();
        let extendSessionInterval = window.setInterval(extendSessionFun, 60000);

        return () => {
            if (extendSessionInterval) {
                window.clearInterval(extendSessionInterval);
                extendSessionInterval = false;
            }

            document.removeEventListener("cet.accessmanagement.login", onLogin);
            document.removeEventListener("cet.accessmanagement.logout", onLogout);
            document.removeEventListener("cet.accessmanagement.sessionchange", onSessionchange);

            document.removeEventListener("mousedown,touchstart,touchmove", setExtendSession);
            window.removeEventListener('resize', setExtendSession);
        };
    }, []);

    const initUser = (user) => {
        if (user && user.userIsAdmin) {
            setUser(user);
            setIsStart(false);
        }
        else {
            setUser(null);
        }
        setUserLoading(false);
    };

    const getUser = (showLoader) => {
        setUserLoading(showLoader);
        window.cet.accessmanagement.getSessionAsync().then(user => {
            initUser(user);
        }).catch(error => {
            initUser();
        });
    };

    return <UserContext.Provider value={[user, setUser]}>
        {userLoading && <Loader />}
        {!user && !userLoading && <Dialog closeIcon={false} onClose={() => { getUser(true); }} title={localization.labels.user_permissions_popup.title}>
            <div style={{ margin: '1em 0' }}>
                <div>{localization.labels.user_permissions_popup.message_part_1}</div>
                <div>{localization.labels.user_permissions_popup.message_part_2}<a target="_blank" href={`https://myofek${getEnvDomain(false)}cet.ac.il/`}>myOfek</a>{localization.labels.user_permissions_popup.message_part_3}</div>
                <div style={{ margin: '10px 0 0 0' }}>{localization.labels.user_permissions_popup.message_part_4}<a onClick={(e) => { getUser(true); e.stopPropagation(); e.preventDefault(); return false; }} href="">{localization.labels.user_permissions_popup.message_part_5}</a>{localization.labels.user_permissions_popup.message_part_6}</div>
            </div>
        </Dialog>}
        {!isStart && props.children}
    </UserContext.Provider>;
};